/**
 * Shader Configuration
 * Must be imported BEFORE any Babylon.js code to configure embedded shaders
 *
 * This file imports all shaders used by the application to ensure they're
 * available in Effect.ShadersStore before any materials or effects are created.
 */
import { Effect } from '@babylonjs/core/Materials/effect';

// Import PBR shaders - used by PBRMaterial for rendering 3D models
import "@babylonjs/core/Shaders/pbr.fragment";
import "@babylonjs/core/Shaders/pbr.vertex";
import "@babylonjs/core/Shaders/pass.fragment";

// Import Standard Material shaders - used by StandardMaterial
import "@babylonjs/core/Shaders/default.fragment";
import "@babylonjs/core/Shaders/default.vertex";

// Import HDR texture shaders - used by HDRCubeTexture for environment maps
import "@babylonjs/core/Shaders/rgbdDecode.fragment";

// Import particle shaders - used by ParticleSystem
import "@babylonjs/core/Shaders/particles.vertex";
import "@babylonjs/core/Shaders/particles.fragment";

// Configure Babylon.js to use embedded shaders instead of loading from URLs
Effect.ShadersRepository = "";

console.log('[Shader Config] Effect.ShadersRepository set to empty string for embedded shaders');
